<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="区域名称">
                  <el-input  v-model="queryForm.areaName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashStorageAreaList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashStorageArea"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashStorageArea(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashStorageArea(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashStorageAreaList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washStorageAreaList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="areaName"
        label="区域名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="startSeq"
        label="开始序号"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="endSeq"
        label="结束序号"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="currentSeq"
            label="当前序号"
        > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="unitSize"
        label="单元存放数量"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashStorageArea(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashStorageArea(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashStorageArea(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washStorageAreaStates[washStorageAreaState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washStorageArea"
          ref="washStorageAreaForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="区域名称"
            prop="areaName"
          >
            <el-input
              size="small"
              v-model="washStorageArea.areaName"
              :disabled="washStorageAreaState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="开始序号"
            prop="startSeq"
          >
            <el-input
              size="small"
              v-model="washStorageArea.startSeq"
              :disabled="washStorageAreaState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="结束序号"
            prop="endSeq"
          >
            <el-input
              size="small"
              v-model="washStorageArea.endSeq"
              :disabled="washStorageAreaState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
                label="当前序号"
                prop="currentSeq"
            >
                <el-input
                    size="small"
                    v-model="washStorageArea.currentSeq"
                    :disabled="washStorageAreaState == 'check'"
                ></el-input>
            </el-form-item>
          <el-form-item
            label="单元存放数量"
            prop="unitSize"
          >
            <el-input
              size="small"
              v-model="washStorageArea.unitSize"
              :disabled="washStorageAreaState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washStorageAreaState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashStorageAreaList();
                    this.getWashStorageAreaList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashStorageAreaList();
                    this.getWashStorageAreaList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     areaName: '', //区域名称
                     startSeq: '', //开始序号
                     endSeq: '', //结束序号
                     unitSize: '', //单元存放数量
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washStorageAreaState: 'add',
                washStorageAreaStates: {
                    add: '新建存放区域',
                    check: '查看存放区域',
                    edit: '修改存放区域'
                },

                multipleSelection: [],
                washStorageAreaList: [],
                washStorageArea: {
                    id: '', //ID
                    areaName: '', //区域名称
                    startSeq: '', //开始序号
                    endSeq: '', //结束序号
                    unitSize: '', //单元存放数量
                    createTime: '', //创建时间
                    currentSeq: ''
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    areaName: [{ required: true, message: '区域名称不能为空', trigger: 'blur' }],
                    startSeq: [{ required: true, message: '开始序号不能为空', trigger: 'blur' }],
                    endSeq: [{ required: true, message: '结束序号不能为空', trigger: 'blur' }],
                    unitSize: [{ required: true, message: '单元存放数量不能为空', trigger: 'blur' }],
                    currentSeq: [{ required: true, message: '当前序号不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            this.getWashStorageAreaList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashStorageAreaList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washStorageAreaList = [];
            },
            resetDialog() {
                this.washStorageAreaState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      areaName: '', //区域名称
                      startSeq: '', //开始序号
                      endSeq: '', //结束序号
                      unitSize: '', //单元存放数量
                };
                this.getWashStorageAreaList();
            },
            closeDialog() {
                this.showDialog = false
                this.washStorageArea = {
                      id: '', //ID
                      areaName: '', //区域名称
                      startSeq: '', //开始序号
                      endSeq: '', //结束序号
                      unitSize: '', //单元存放数量
                      createTime: '', //创建时间
                      currentSeq: ''
                };
            },
            submitForm() {
                if (this.washStorageAreaState == 'add') {
                    this.$refs.washStorageAreaForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/storagearea/add`,{ ...this.washStorageArea }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashStorageAreaList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washStorageAreaState == 'edit') {
                    this.$refs.washStorageAreaForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/storagearea/edit`,{ ...this.washStorageArea }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashStorageAreaList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashStorageArea() {
                this.showDialog = true;
                this.washStorageAreaState = 'add';
            },
            checkWashStorageArea(washStorageAreaId) {
                console.log(washStorageAreaId);
                this.currentWashStorageAreaId = washStorageAreaId;

                this.getWashStorageAreaById();
                this.showDialog = true;
                this.washStorageAreaState = 'check';
            },
            editWashStorageArea(washStorageAreaId) {
                console.log('washStorageArea', washStorageAreaId);
                if (washStorageAreaId) {
                    this.currentWashStorageAreaId = washStorageAreaId;
                    this.getWashStorageAreaById();
                } else {
                    this.washStorageArea = { ...this.washStorageArea, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washStorageAreaState = 'edit';
            },
            deleteWashStorageArea(washStorageAreaId) {
                let ids = '';
                if (washStorageAreaId) {
                    ids = washStorageAreaId;
                } else {
                    ids = this.multipleSelection.map((washStorageArea) => washStorageArea.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/storagearea/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashStorageAreaList();
                                this.getWashStorageAreaList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashStorageAreaList() {
                this.resetWashStorageAreaList();
                this.getWashStorageAreaList();
            },
            getWashStorageAreaList(query = {}) {
                this.loading = true;
                get(`/wash/storagearea/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washStorageAreaList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashStorageAreaById() {
                get(`/wash/storagearea/get`,{ id: this.currentWashStorageAreaId }).then((res) =>{
                    if(res.success){
                      this.washStorageArea = { ...this.washStorageArea, ...res.washStorageArea };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashStorageAreaList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/storagearea/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/storagearea/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/storagearea/importData`,formData);
              this.refreshWashStorageAreaList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashStorageAreaList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashStorageAreaList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>